"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const sensitivityskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-sensitivityskin` : '') + (description ? ` desc-sensitivityskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-sensitivityskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-sensitivityskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.46 20.4a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.26 20.4a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.76 20.4a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.55 20.4a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.45 16.65a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.99 16.65a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.52 16.65a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.52 12.86a5.59 5.59 0 0 1 6.28-.4l2.8 1.67a.75.75 0 0 1-.76 1.29l-2.8-1.66a4.09 4.09 0 0 0-4.6.29 5.61 5.61 0 0 1-6.85 0 4.16 4.16 0 0 0-4.7-.24l-2.65 1.63a.75.75 0 1 1-.8-1.28l2.66-1.63a5.66 5.66 0 0 1 6.4.34 4.11 4.11 0 0 0 5.02 0Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.86.75a1 1 0 0 1 .45.11c.1.05.2.11.27.2l.09.08.07.1a1 1 0 0 1 .1.23l.03.12c1.03 6-3.44 9.55-6.97 9.55a4.44 4.44 0 0 1-3.49-1.7l-.67.58a.75.75 0 0 1-.98-1.14l.93-.79a4.43 4.43 0 0 1-.23-1.39c0-1.5.47-2.57 1.33-3.28a5.9 5.9 0 0 1 2.92-1.08c.51-.08 1.06-.14 1.58-.2a23.6 23.6 0 0 0 1.53-.2 5.2 5.2 0 0 0 2.45-.98l.09-.07a.97.97 0 0 1 .5-.14Zm-.37 1.87c-.76.42-1.6.64-2.4.8-.55.09-1.1.16-1.64.21l-1.52.19a4.5 4.5 0 0 0-2.19.76c-.43.36-.78.95-.78 2.12l.02.32A13 13 0 0 1 13.18 5a.75.75 0 0 1 .4 1.44A11.5 11.5 0 0 0 9.63 8.4l-.07.07.26.3c.56.56 1.3.87 2.08.87 2.52 0 5.97-2.48 5.59-7.02Z",
    fill: "#232323"
  }));
};
var _default = exports.default = sensitivityskin;